 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"channelStoriesPage-mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPage-mobileChannelPage":"channelStoriesPage-mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPage-mobileChannelPage","channelStoriesPage":"channelStoriesPage","mobile403":"mobile403","mobile404":"mobile404","mobileApplyPage-mobileJoinPage-mobileLoginPage":"mobileApplyPage-mobileJoinPage-mobileLoginPage","mobileLoginPage":"mobileLoginPage","mobileChangePasswordPage":"mobileChangePasswordPage","mobileExploreCategoryPage":"mobileExploreCategoryPage","mobileExploreResultsPage-mobileSearchResultsPage":"mobileExploreResultsPage-mobileSearchResultsPage","mobileExploreResultsPage":"mobileExploreResultsPage","mobileSearchResultsPage":"mobileSearchResultsPage","mobileFavoritesPage":"mobileFavoritesPage","mobileFilmFest":"mobileFilmFest","mobileGifVideoPage":"mobileGifVideoPage","mobileResetPasswordPage":"mobileResetPasswordPage","mobileTrendingPage":"mobileTrendingPage","vendors-gifEditPanel-gifMakerFinalize":"vendors-gifEditPanel-gifMakerFinalize","vendors-gifEditPanel":"vendors-gifEditPanel","gifEditPanel":"gifEditPanel","vendors-gifMakerFinalize-mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPage-mobileC-1c140ebc":"vendors-gifMakerFinalize-mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPage-mobileC-1c140ebc","gifMakerFinalize-mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPage-mobileChannelPage":"gifMakerFinalize-mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPage-mobileChannelPage","mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPage-mobileChannelPage":"mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPage-mobileChannelPage","mobileChannelBranchPage":"mobileChannelBranchPage","mobileChannelLeafPage":"mobileChannelLeafPage","mobileChannelListPage":"mobileChannelListPage","mobileChannelPage":"mobileChannelPage","vendors-gifMakerVideoTrim-mobileGifMaker":"vendors-gifMakerVideoTrim-mobileGifMaker","vendors-gifMakerFinalize-mobileGifMaker":"vendors-gifMakerFinalize-mobileGifMaker","vendors-mobileApplyPage-mobileGifMaker":"vendors-mobileApplyPage-mobileGifMaker","mobileGifMaker":"mobileGifMaker","mobileApplyPage":"mobileApplyPage","vendors-mobileDashboard":"vendors-mobileDashboard","mobileDashboard":"mobileDashboard","vendors-mobileJoinPage":"vendors-mobileJoinPage","mobileJoinPage":"mobileJoinPage","vendors-mobileTeamPage":"vendors-mobileTeamPage","mobileTeamPage":"mobileTeamPage","vendors-showdown":"vendors-showdown","gifDetailMedia":"gifDetailMedia","creationAnimate":"creationAnimate","creationCutOut":"creationCutOut","creationUpload":"creationUpload","desktopUploadFinalize":"desktopUploadFinalize","gifMakerSlideshow":"gifMakerSlideshow","gifMakerFinalize":"gifMakerFinalize","gifMakerVideoTrim":"gifMakerVideoTrim","aboutPage":"aboutPage","appsLanding":"appsLanding","artists":"artists","curationStation":"curationStation","desktopChannelStories":"desktopChannelStories","desktopStory":"desktopStory","desktopVideoDetail":"desktopVideoDetail","desktopVideos":"desktopVideos","filmFest":"filmFest","homebase":"homebase","homepageBeta":"homepageBeta","vendors-dvr":"vendors-dvr","dvr":"dvr"}[chunkId]||chunkId) + "." + {"0":"05580a9d","channelStoriesPage-mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPage-mobileChannelPage":"a9df47b1","channelStoriesPage":"24e977a1","mobile403":"a1e55a54","mobile404":"b0a5fced","mobileApplyPage-mobileJoinPage-mobileLoginPage":"547f67dc","mobileLoginPage":"3b541b8d","mobileChangePasswordPage":"1486660d","mobileExploreCategoryPage":"ab3c27b7","mobileExploreResultsPage-mobileSearchResultsPage":"26bf3afb","mobileExploreResultsPage":"ce318dcb","mobileSearchResultsPage":"828248b3","mobileFavoritesPage":"99a62aa1","mobileFilmFest":"4248647e","mobileGifVideoPage":"32ae0773","mobileResetPasswordPage":"3fb3b668","mobileTrendingPage":"316e7fcb","vendors-gifEditPanel-gifMakerFinalize":"899137ca","vendors-gifEditPanel":"37c4d3f7","gifEditPanel":"fd90a6b5","vendors-gifMakerFinalize-mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPage-mobileC-1c140ebc":"4e3ff27c","gifMakerFinalize-mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPage-mobileChannelPage":"48c832b9","mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPage-mobileChannelPage":"7caf0f58","mobileChannelBranchPage":"f7862b32","mobileChannelLeafPage":"5a4c0db4","mobileChannelListPage":"9686894d","mobileChannelPage":"320a7a21","vendors-gifMakerVideoTrim-mobileGifMaker":"5bc1ce83","vendors-gifMakerFinalize-mobileGifMaker":"4ba2f1f1","vendors-mobileApplyPage-mobileGifMaker":"9bc1891f","mobileGifMaker":"21dc7a86","mobileApplyPage":"779ec988","vendors-mobileDashboard":"db23123b","mobileDashboard":"0ec99094","vendors-mobileJoinPage":"31c5823b","mobileJoinPage":"b970ebeb","vendors-mobileTeamPage":"1d05a894","mobileTeamPage":"2a0bf2e8","vendors-showdown":"38a0da76","gifDetailMedia":"184c1841","creationAnimate":"d74392b6","creationCutOut":"542170dd","creationUpload":"88928584","desktopUploadFinalize":"83a1e648","gifMakerSlideshow":"835fa0e2","gifMakerFinalize":"c89d2030","gifMakerVideoTrim":"e64d9529","aboutPage":"37322241","appsLanding":"fe66ca14","artists":"ea225790","curationStation":"974df65b","desktopChannelStories":"f4af789b","desktopStory":"bb1efd71","desktopVideoDetail":"897221db","desktopVideos":"7d10eae0","filmFest":"088907f7","homebase":"5ba69eb7","homepageBeta":"d2077a3b","vendors-dvr":"595bc098","dvr":"a2f6fce5"}[chunkId] + ".bundle.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/static/dist/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
